export function simplemdeConfig(config) {
  return Object.assign(
    {},
    {
      autoDownloadFontAwesome: false,
    },
    config
  );
}
